// extracted by mini-css-extract-plugin
module.exports = {"seoCarOverviewTabs":"_3qVBp","active":"_1yVnq"};